export const rapportages = (state) => state.rapportages;
